module.exports = __webpack_public_path__ + "img/001整体.6f43d121.jpg";